import { render, staticRenderFns } from "./delarationDetail.vue?vue&type=template&id=707393e6&scoped=true"
import script from "./delarationDetail.vue?vue&type=script&lang=js"
export * from "./delarationDetail.vue?vue&type=script&lang=js"
import style0 from "./delarationDetail.vue?vue&type=style&index=0&id=707393e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707393e6",
  null
  
)

export default component.exports